import * as React from 'react'
function NotFound() {
  return <p>Oops. This page was either moved or doesn't exist any longer.</p>
}

export default NotFound